export const onError = ({ currentTarget }) => {
  currentTarget.src = "https://www.pngwing.com/en/free-png-zvosv";
};
